import { Flex, Skeleton } from '@backstage/ui';
import { paginationOptions } from './config';

const TABLE_ROW_COUNT = paginationOptions.pageSize;

/**
 * Loading placeholder that mirrors the Pulse list pages (a filter bar above a
 * table) so the page body keeps its shape while data is fetched. Render it
 * inside the page's existing Header/Container so the title stays visible.
 */
export const PulseListSkeleton = () => (
  <Flex direction="column" gap="6">
    <Skeleton width="100%" height="var(--bui-space-8)" />

    <Flex direction="column" gap="2">
      <Skeleton width="100%" height={44} />
      {Array.from({ length: TABLE_ROW_COUNT }, (_, index) => (
        <Skeleton
          key={`row-${index}`}
          width="100%"
          height="var(--bui-space-8)"
        />
      ))}
    </Flex>
  </Flex>
);
